import React from "react";
import "./StepsLandingPage.scss";
import { useNavigate } from "react-router-dom";
interface Step {
  icon: React.ReactNode;
  title: string;
  description: string;
}

interface StepsComponentProps {
  title: string;
  subtitle: string;
  description: string;
  steps: Step[];
  buttonText?: string;
  onButtonClick?: () => void;
}

const StepsComponent: React.FC<StepsComponentProps> = ({
  title,
  subtitle,
  description,
  steps,
  buttonText = "Get Started",
}) => {
  const navigate = useNavigate();
  const onButtonClick = () => {
    navigate("/register");
  };
  return (
    <section className="steps-component">
      <div className="steps-content">
        <div className="steps-header">
          <span className="steps-subtitle">{subtitle}</span>
          <h2 className="steps-title">{title}</h2>
          <p className="steps-description">{description}</p>

          <button className="steps-button" onClick={onButtonClick}>
            {buttonText}
          </button>
        </div>

        <div className="steps-grid">
          {steps.map((step, index) => (
            <div key={index} className="step-item">
              <div className="step-icon-container">{step.icon}</div>
              <h3 className="step-title">{step.title}</h3>
              <p className="step-description">{step.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default StepsComponent;
